import { FeatureFlagDeclarations } from '../feature-flag-declarations';
import { useFeatureFlag } from './use-feature-flag';

export const useEnableHomePage = () => {
  return useFeatureFlag(FeatureFlagDeclarations.enableHomePage);
};
